import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SearchHistoryIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SearchHistoryIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C14.5913 20.25 16.9033 19.0561 18.417 17.1855C18.6775 16.8636 19.1498 16.8137 19.4718 17.0743C19.7938 17.3349 19.8436 17.8071 19.583 18.1291C17.7968 20.3365 15.0632 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.1857 2.25 21.4259 6.29844 21.7323 11.4071L22.1695 10.9697C22.4624 10.6768 22.9373 10.6767 23.2302 10.9696C23.5231 11.2624 23.5232 11.7373 23.2304 12.0303L21.231 14.0303C21.0903 14.1709 20.8996 14.25 20.7007 14.25C20.5017 14.25 20.311 14.171 20.1703 14.0304L18.1697 12.0304C17.8768 11.7376 17.8767 11.2627 18.1695 10.9697C18.4624 10.6768 18.9373 10.6767 19.2302 10.9696L20.25 11.9891C20.2441 7.43775 16.5527 3.75 12 3.75ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V11.5986L15.416 13.376C15.7607 13.6057 15.8538 14.0714 15.624 14.416C15.3943 14.7607 14.9286 14.8538 14.584 14.624L11.584 12.624C11.3753 12.4849 11.25 12.2508 11.25 12V7C11.25 6.58579 11.5858 6.25 12 6.25Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SearchHistoryIcon;
